import { listGames } from './GameRegistry';

export function getDefaultConfig(key) {
  const entry = listGames().find((g) => g.key === key);
  if (!entry) return {};
  const schema = entry.config || {};
  const defaults = entry.defaults || {};
  const output = {};
  Object.entries(schema).forEach(([field, definition]) => {
    let fallback = defaults[field] ?? definition.default ?? '';
    if (field === 'Number_of_rounds') fallback = defaults[field] ?? definition.default ?? 5;
    output[field] = typeof fallback === 'number' ? fallback : String(fallback ?? '');
  });
  if ('Number_of_rounds' in output) output.Number_of_rounds = Number(output.Number_of_rounds);
  return output;
}
